//Componentes generales
import React, { useState } from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWarehouse,
  faCaretDown,
  faCaretUp,
} from "@fortawesome/free-solid-svg-icons";

import WarehouseReqSectorList from "../WarehouseReqSectorList/WarehouseReqSectorList";

const RenderRow = ({ index, style, reqsSectors = [], filter }) => {
  const [reqSectorSelected, setReqSectorSelected] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);

  const handleClick = (reqSector) => {
    reqSectorSelected == reqSector
      ? setReqSectorSelected("")
      : setReqSectorSelected(reqSector);
    setOpenDropdown((prevState) => !prevState);
  };

  if (filter === "") {
    return (
      <div
        style={style}
        className="reqSectorRow"
        id={reqsSectors[index].codSem}
      >
        <div className="reqSectorDataRow">
          <div className="list-item-icon-w">
            <FontAwesomeIcon icon={faWarehouse} />
          </div>
          <div className="label-title-reqs-sectors">
            Sector de la empresa:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors[index].codSem}
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Descripción:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors[index].descrp}
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Depósito:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors[index].deposi} ({reqsSectors[index].deposiDescrp})
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Sector depósito:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors[index].sectorDeposi} (
              {reqsSectors[index].sectorDeposiDescrp})
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    const reqsSectors_filters = reqsSectors.filter(
      (rS) =>
        rS.codSem.toLowerCase().includes(filter.toLowerCase()) ||
        rS.descrp.toLowerCase().includes(filter.toLowerCase())
    );
    return (
      <div
        style={style}
        className="reqSectorRow"
        id={reqsSectors_filters[index].codSem}
      >
        <div className="reqSectorDataRow">
          <div className="list-item-icon-w">
            <FontAwesomeIcon icon={faWarehouse} />
          </div>
          <div className="label-title-reqs-sectors">
            Sector de la empresa:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors_filters[index].codSem}
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Descripción:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors_filters[index].descrp}
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Depósito:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors_filters[index].deposi} (
              {reqsSectors_filters[index].deposiDescrp})
            </div>
          </div>
          <div className="label-title-reqs-sectors">
            Sector depósito:{" "}
            <div className="label-reqs-sectors">
              {reqsSectors_filters[index].sectorDeposi} (
              {reqsSectors_filters[index].sectorDeposiDescrp})
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default RenderRow;